<template>
  <div class="card overflow-hidden">
    <div :style="disable ? 'filter:opacity(0.15)' : ''">
      <div v-if="isNew" :class="$style.new">
        New
      </div>
      <div class="card-body">
        <a
          href="#"
          v-on:click="toggleFavorite"
          :class="[$style.favorite, favorite ? 'text-dark' : 'text-gray-3']"
        >
          <i class="fe fe-heart font-size-21"></i>
        </a>
        <div :class="$style.image" class="border-bottom height-250 mb-3">
          <img class="img-fluid" :src="image" :alt="description" />
        </div>
        <div class="font-size-24 font-weight-bold text-dark mb-2">
          {{ name }}
          <div class="align-text-top font-size-14 mr-2">
            {{ price }}
            <del v-if="oldPrice">
              {{ oldPrice }}
            </del>
          </div>
        </div>
        <div>
          <pre>
            {{ description }}
          </pre>
          <b-button
            :disabled="disable"
            variant="success"
            @click="$emit('addtool', tool)"
            >Get Tool</b-button
          >
          <!-- &nbsp;<b-button variant="primary">More Info</b-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tool-shop-tool",
  props: [
    "isNew",
    "isFavorite",
    "image",
    "description",
    "name",
    "price",
    "oldPrice",
    "tool",
    "disable"
  ],
  data: function() {
    return {
      favorite: this.isFavorite
    };
  },
  methods: {
    toggleFavorite: function(event) {
      event.preventDefault();
      this.favorite = !this.favorite;
    }
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
